import React from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../../app/hooks';

import './DriverNav.scss';

export interface DriverNavProps {
  driverId: string;
}

export function DriverNav(props: DriverNavProps) {
  const { driverId } = props;
  const navigate = useNavigate();

  const drivers = useAppSelector(state => state.driversV2.drivers) || [];
  const index = drivers.findIndex(d => d.id === driverId);

  // While the roster is still loading, or the current driver isn't in the
  // list, there's no prev/next to show — render nothing.
  if (index === -1 || drivers.length <= 1) {
    return null;
  }

  // Wrap around at the ends.
  const prevDriver = drivers[(index - 1 + drivers.length) % drivers.length];
  const nextDriver = drivers[(index + 1) % drivers.length];

  const goTo = (id: string) => () => navigate(`/drivers/${id}`);

  return (
    <div className='driver-nav-component'>
      <div className='icon-container' onClick={goTo(prevDriver.id)}>
        <BsChevronLeft className='icon' />
      </div>

      <div className='name neighbor' onClick={goTo(prevDriver.id)}>
        {prevDriver.name}
      </div>

      <div className='divider'>|</div>

      <div className='name neighbor' onClick={goTo(nextDriver.id)}>
        {nextDriver.name}
      </div>

      <div className='icon-container' onClick={goTo(nextDriver.id)}>
        <BsChevronRight className='icon' />
      </div>
    </div>
  );
}
